import store from "./redux-setup";

export default store;
